import { motion } from 'framer-motion';
import '../styles/Projects.css';
import { cardVariants } from '../animations/animationConfigs';

const projects = [
    {
        title: "Lu&Me",
        image: "./images/projects/lume.gif",
        githubLink: "https://github.com/1-JaeYo/lu-me"
    },
    {
        title: "UniSalon Barbershop",
        image: "https://cdn.pixabay.com/animation/2023/02/28/13/20/13-20-33-357_512.gif",
        githubLink: "https://github.com/1-JaeYo/UniSalon-Barbershop"
    },
    {
        title: "AI Fake News Detector",
        image: "https://media.tenor.com/MHnBPLKmpTwAAAAM/real-or-fake-moby-rich.gif",
        githubLink: "https://github.com/1-JaeYo/AI-Fake-News-Detector"
    },

    {
        title: "Stopwatch",
        image: "./images/projects/stopwatch.gif",
        githubLink: "https://github.com/1-JaeYo/Stopwatch"
    },
    {
        title: "Youtube Downloader",
        image: "./images/projects/ytdownload.gif",
        githubLink: "https://github.com/1-JaeYo/Youtube-Downloader"
    },
    {
        title: "8Dat (Figma Design)",
        image: "./images/projects/8dat.png",
        githubLink: "#"
    }
];

const Projects = () => {
    return (
        <div className="projects">
            <h1>Some of My Recent Projects</h1>
            <div className="projects-grid">
                {projects.map((project, index) => (
                <motion.div
                    key={index}
                    className="project-card"
                    initial="offscreen"
                    whileInView="onscreen"
                    viewport={{ once: true, amount: 0.8 }}
                    variants={cardVariants}
                    whileHover={{ scale: 1.05 }}
                >
                    <img src={project.image} alt={project.title} />
                    <div className="overlay">
                        <a href={project.githubLink} target="_blank" rel="noopener noreferrer">
                            <GitHubLogo />
                        </a>
                    </div>
                    <div className="project-info">
                        <h2>{project.title}</h2>
                        <p>{project.description}</p>
                    </div>
                </motion.div>
                ))}
            </div>
            <hr id='contact' />
        </div>
    );
};

const GitHubLogo = () => (
    <svg
        className="github-logo"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        width="50"
        height="50"
    >
    <path d="M12 2C6.48 2 2 6.48 2 12c0 4.42 2.87 8.17 6.84 9.5.5.09.66-.22.66-.48 0-.24-.01-.87-.01-1.71-2.78.61-3.37-1.34-3.37-1.34-.45-1.14-1.11-1.44-1.11-1.44-.91-.62.07-.61.07-.61 1.01.07 1.54 1.04 1.54 1.04.89 1.53 2.34 1.09 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.56-1.11-4.56-4.93 0-1.09.39-1.98 1.03-2.68-.1-.25-.45-1.27.1-2.65 0 0 .84-.27 2.75 1.02A9.56 9.56 0 0112 6.8c.85.004 1.7.115 2.5.337 1.9-1.29 2.75-1.02 2.75-1.02.55 1.38.2 2.4.1 2.65.64.7 1.03 1.59 1.03 2.68 0 3.83-2.34 4.67-4.57 4.92.36.31.68.93.68 1.88 0 1.36-.01 2.46-.01 2.8 0 .27.16.58.67.48A10.02 10.02 0 0022 12c0-5.52-4.48-10-10-10z"></path>
    </svg>
);

export default Projects;
